export const varsDmpConsentChangeEvent = {
  tipo: 'interaccion',
  detalle: 'aceptacion_consentimiento',
  accion: undefined
};

export const UNAUTHENTICATED = 'no autenticado';

export const MAX_ADBLOCK_DETECT_TIME = 3000;
